let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5nnaS")).then(() => parcelRequire('g5gWI'));